import './lib/store';
import './lib/pubsub';
import './lib/app-scroll';
import './components/banners';
import './components/copy-to-clipboard';
import './components/countdown-timer';
import './components/on-load-click-radio-buttons';
import './components/search-close';
import './components/accordion';
import './components/language-selection-trigger';
import './components/site-modal';

// Donation form
// ----------------------------------------------------------------
import './components/donation-form/handle-updating-donation-form-trigger-with-plausible-props';
import './components/donation-form/on-load';
import './components/donation-form/step-trigger';
import './components/donation-form/select-payment-method';
import './components/donation-form/select-donation-amount';
import './components/donation-form/select-donation-type';
import './components/donation-form/input-validation-on-change';
import './components/donation-form/direction-forward-trigger';
import './components/donation-form/direction-backward-trigger';
import './components/donation-form/marketing-modal-controls';
import './components/donation-form/submit';
import './components/donation-form/form-progress-tracker';
import './components/input-checked-state';

// Petition form
// ----------------------------------------------------------------
import './components/petitions-form/form-submit';
import './components/petitions-form/accordion';
import './components/newsletter-form/form';
import './components/petition-letter';

// Calculator
// ----------------------------------------------------------------
import './components/number-control-field';
import './components/calculator';